'use strict';

function LatestNews() {
  $('.paragraph--type--latest-news article').matchHeight();
};
export default LatestNews;
